(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cx-business-cart"]) return;
  try {
    
(() => {
  const init = () => {
    const root = document.querySelector('[data-business-cart]');
    const form = root?.querySelector('[data-business-cart-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-business-cart-config]').textContent);
    const quantities = [...form.querySelectorAll('[data-business-qty]')];
    const checkout = form.querySelector('[data-business-checkout]');
    const update = form.querySelector('[data-business-update]');
    const dirtyMessage = form.querySelector('[data-business-dirty]');
    const pendingMessage = form.querySelector('[data-business-pending]');
    const pendingKey = 'sync-b2b-order-pending';
    const noticeKey = 'sync-b2b-cart-notice';
    let notice = '';
    let pending = false;
    let busy = false;
    let nativeAllowed = false;
    let storageError = false;
    try { pending = !!sessionStorage.getItem(pendingKey); notice = sessionStorage.getItem(noticeKey) || ''; sessionStorage.removeItem(noticeKey); } catch (_) { pending = true; storageError = true; }
    const initial = quantities.map(input => input.value);
    const refresh = () => {
      const dirty = quantities.some((input, index) => input.value !== initial[index]);
      if (dirtyMessage) dirtyMessage.hidden = !dirty;
      pendingMessage.hidden = !pending && !notice;
      if (notice && config.text[notice]) pendingMessage.textContent = config.text[notice];
      if (storageError) pendingMessage.textContent = config.text.storage;
      if (checkout) checkout.disabled = busy || dirty || pending || checkout.hasAttribute('data-checkout-locked');
      update.disabled = busy || storageError;
      if (form.hasAttribute('data-business-empty-confirm')) form.hidden = !pending;
      form.setAttribute('aria-busy', String(busy));
    };
    const validate = input => {
      const value = Number(input.value);
      const minimum = Number(input.dataset.min || 1);
      const increment = Number(input.dataset.inc || 1);
      const valid = /^\d+$/.test(input.value) && Number.isSafeInteger(value) && value >= 0 && (value === 0 || value >= minimum && value % increment === 0);
      input.setCustomValidity(valid ? '' : input.dataset.ruleMessage);
      return valid && input.validity.valid;
    };
    const snapshot = async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(config.cartUrl + '.js', {credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('error');
        const cart = await response.json();
        if (!Array.isArray(cart.items) || cart.currency !== config.currency) throw new Error('error');
        return cart;
      } finally { clearTimeout(timer); }
    };
    const isInitial = cart => cart.total_price === config.total && cart.items.length === config.items.length && cart.items.every((item, index) => item.key === config.items[index].key && item.quantity === config.items[index].quantity);
    const signature = item => JSON.stringify([String(item.variant_id), String(item.selling_plan_id || item.selling_plan_allocation?.selling_plan?.id || 0), Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
    const amounts = items => {
      const result = new Map();
      items.forEach(item => { if (item.quantity > 0) result.set(signature(item), (result.get(signature(item)) || 0) + item.quantity); });
      return result;
    };
    const confirmedAmounts = (cart, desired) => {
      const expected = amounts(desired);
      const actual = amounts(cart.items);
      return expected.size === actual.size && [...expected].every(([key, value]) => actual.get(key) === value);
    };
    quantities.forEach(input => input.addEventListener('input', () => { validate(input); refresh(); }));
    form.querySelectorAll('[data-business-remove]').forEach(button => button.addEventListener('click', () => {
      const input = document.getElementById(button.dataset.businessRemove);
      input.value = '0';
      validate(input);
      refresh();
      form.requestSubmit(update);
    }));
    form.addEventListener('submit', async event => {
      if (nativeAllowed) return;
      event.preventDefault();
      if (busy || storageError) return;
      let invalid = false;
      quantities.forEach(input => { if (!validate(input)) invalid = true; });
      if (invalid) { form.reportValidity(); return; }
      const isCheckout = event.submitter?.name === 'checkout';
      if (isCheckout && (!checkout || checkout.disabled)) return;
      const desired = config.items.map((item, index) => ({...item, quantity: Number(quantities[index].value)}));
      busy = true;
      refresh();
      try {
        const current = await snapshot();
        if (!isInitial(current)) { sessionStorage.setItem(noticeKey, 'changed'); window.location.replace(config.cartUrl); return; }
        if (isCheckout) {
          busy = false;
          refresh();
          nativeAllowed = true;
          form.requestSubmit(checkout);
          return;
        }
        const body = new FormData(form);
        body.append('update', '');
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 20000);
        let response;
        try {
          response = await fetch(config.cartUrl, {method: 'POST', credentials: 'same-origin', body, signal: controller.signal});
          await response.text();
        } finally { clearTimeout(timer); }
        if (!response.ok) throw new Error('error');
        const confirmed = await snapshot();
        if (!confirmedAmounts(confirmed, desired)) { sessionStorage.setItem(noticeKey, 'rejected'); window.location.replace(config.cartUrl); return; }
        sessionStorage.removeItem(pendingKey);
        pending = false;
        window.location.replace(config.cartUrl);
      } catch (error) {
        pending = true;
        pendingMessage.textContent = config.text[error.message] || config.text.uncertain;
        pendingMessage.hidden = false;
        busy = false;
        if (checkout) checkout.disabled = true;
        update.disabled = false;
        form.setAttribute('aria-busy', 'false');
      }
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted) window.location.reload();
      else refresh();
    });
    refresh();
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-collection"]) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.guidedCollectionReady) return;
    root.dataset.guidedCollectionReady = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    const mobileQuery = window.matchMedia('(max-width: 640px)');
    const help = root.querySelector('.cx-guided-collection__help');
    const grid = root.querySelector('.cx-guided-collection__grid');
    const helpPlaceholder = help ? document.createComment('collection-help-position') : null;
    if (help && helpPlaceholder) help.before(helpPlaceholder);
    const moveHelp = (parent, before) => {
      if (!help || !parent || (help.parentNode === parent && help.nextSibling === before)) return;
      const focused = help.contains(document.activeElement) ? document.activeElement : null;
      parent.insertBefore(help, before);
      if (focused && focused.isConnected && document.activeElement !== focused) focused.focus({preventScroll:true});
    };
    const placeHelp = () => {
      if (!help || !grid || !helpPlaceholder?.parentNode) return;
      if (mobileQuery.matches) moveHelp(grid.parentNode, grid.nextSibling === help ? help.nextSibling : grid.nextSibling);
      else moveHelp(helpPlaceholder.parentNode, helpPlaceholder.nextSibling === help ? help.nextSibling : helpPlaceholder.nextSibling);
    };
    mobileQuery.addEventListener('change', placeHelp, {signal});
    placeHelp();
    const controls = root.querySelector('[data-cx-collection-filters]');
    const buttons = controls ? Array.from(controls.querySelectorAll('[data-cx-collection-filter]')) : [];
    const items = Array.from(root.querySelectorAll('[data-cx-collection-item]'));
    const counter = root.querySelector('[data-cx-collection-count]');
    if (controls) controls.hidden = false;
    buttons.forEach(button => button.addEventListener('click', () => {
      const filter = button.dataset.cxCollectionFilter;
      let count = 0;
      items.forEach(item => {
        const visible = filter === 'all' || item.dataset.cxCollectionItem === filter;
        item.hidden = !visible;
        if (visible) count += 1;
      });
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      if (counter) counter.textContent = count === 1 ? counter.dataset.countOne : counter.dataset.countTemplate.replace('__count__', String(count));
    }, {signal}));
    document.addEventListener('shopify:section:unload', event => {
      if (event.target !== root && !event.target.contains(root)) return;
      controller.abort();
      if (helpPlaceholder?.parentNode) {
        moveHelp(helpPlaceholder.parentNode, helpPlaceholder.nextSibling === help ? help.nextSibling : helpPlaceholder.nextSibling);
        helpPlaceholder.remove();
      }
      delete root.dataset.guidedCollectionReady;
    }, {signal});
  };
  const initializeWithin = target => {
    if (target.matches?.('[data-cx-guided-collection]')) init(target);
    target.querySelectorAll('[data-cx-guided-collection]').forEach(init);
  };
  initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-discovery-kit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.kitReady) return;
    root.dataset.kitReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const track = root.querySelector('[data-kit-track]');
    const slides = Array.from(root.querySelectorAll('[data-kit-slide]'));
    const tabs = Array.from(root.querySelectorAll('[data-kit-tab]'));
    const previous = root.querySelector('[data-kit-prev]');
    const next = root.querySelector('[data-kit-next]');
    const controls = root.querySelector('[data-kit-controls]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let frame = 0;
    const setSlide = index => {
      if (!track || !slides.length) return;
      const target = Math.max(0, Math.min(slides.length - 1, index));
      const delta = slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({left:delta,behavior:reducedMotion.matches ? 'auto' : 'smooth'});
    };
    const syncGallery = () => {
      if (!track || !slides.length) return;
      const left = track.getBoundingClientRect().left;
      active = slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best, 0);
      tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(index === active)));
      if (previous) previous.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
    };
    tabs.forEach((tab, index) => tab.addEventListener('click', () => setSlide(index), {signal}));
    previous?.addEventListener('click', () => setSlide(active - 1), {signal});
    next?.addEventListener('click', () => setSlide(active + 1), {signal});
    track?.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      setSlide(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal});
    if (controls) controls.hidden = false;
    const form = root.querySelector('[data-cx-discovery-form]');
    const mainAdd = form?.querySelector('[data-cx-add]');
    const viewCart = root.querySelector('[data-cx-kit-view-cart]');
    const sticky = root.querySelector('[data-kit-sticky]');
    const stickyAdd = root.querySelector('[data-kit-sticky-add]');
    const stickyCart = root.querySelector('[data-kit-sticky-cart]');
    const mainStatus = form?.querySelector('[data-cx-form-status]');
    const stickyStatus = root.querySelector('[data-kit-sticky-status]');
    const purchase = root.querySelector('.cx-discovery__purchase');
    const syncButton = () => {
      if (!mainAdd || !stickyAdd) return;
      const inCart = viewCart && !viewCart.hidden;
      stickyAdd.hidden = Boolean(inCart);
      if (stickyCart) stickyCart.hidden = !inCart;
      stickyAdd.disabled = mainAdd.disabled;
      stickyAdd.textContent = mainAdd.querySelector('span')?.textContent || mainAdd.textContent;
      if (stickyStatus) {
        const message = mainStatus?.textContent.trim() || '';
        const errorMessage = message === root.dataset.kitAdded ? '' : message;
        stickyStatus.textContent = errorMessage;
        stickyStatus.hidden = !errorMessage;
      }
    };
    stickyAdd?.addEventListener('click', () => {
      if (form && mainAdd && !mainAdd.disabled) form.requestSubmit(mainAdd);
    }, {signal});
    const syncSticky = () => {
      if (!sticky || !mainAdd) return;
      const rect = mainAdd.getBoundingClientRect();
      const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cx-header-height')) || 0;
      const mobile = window.matchMedia('(max-width: 960px)').matches;
      const purchaseRect = purchase.getBoundingClientRect();
      root.toggleAttribute('data-kit-purchase-visible', mobile && purchaseRect.top < innerHeight && purchaseRect.bottom > 0);
      sticky.hidden = mobile ? rect.top >= header + 12 && rect.bottom <= innerHeight - 12 : purchaseRect.bottom > header;
      const height = sticky.hidden ? 0 : Math.ceil(sticky.getBoundingClientRect().height);
      root.style.setProperty('--kit-sticky-height', `${height}px`);
      document.documentElement.style.setProperty('--cx-chat-clearance', `${height}px`);
    };
    const sync = () => {frame = 0;syncGallery();syncSticky();};
    const schedule = () => {if (!frame) frame = requestAnimationFrame(sync);};
    const buttonObserver = new MutationObserver(() => {syncButton();schedule();});
    if (mainAdd) buttonObserver.observe(mainAdd, {attributes:true,childList:true,subtree:true,characterData:true});
    if (viewCart) buttonObserver.observe(viewCart, {attributes:true,attributeFilter:['hidden']});
    if (mainStatus) buttonObserver.observe(mainStatus, {childList:true,subtree:true,characterData:true});
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    if (resizeObserver) {
      if (track) resizeObserver.observe(track);
      if (purchase) resizeObserver.observe(purchase);
      if (sticky) resizeObserver.observe(sticky);
    }
    track?.addEventListener('scroll', schedule, {passive:true,signal});
    window.addEventListener('scroll', schedule, {passive:true,signal});
    window.addEventListener('resize', schedule, {passive:true,signal});
    window.addEventListener('pageshow', () => {syncButton();schedule();}, {signal});
    const reveal = hash => {
      let id;
      try {id = decodeURIComponent(hash.slice(1));} catch (_) {return;}
      const detail = document.getElementById(id);
      if (detail?.tagName === 'DETAILS' && root.contains(detail)) detail.open = true;
    };
    root.addEventListener('click', event => {
      const link = event.target.closest?.('a[href]');
      if (link?.hash && link.origin === location.origin && link.pathname === location.pathname) reveal(link.hash);
    }, {signal});
    window.addEventListener('hashchange', () => reveal(location.hash), {signal});
    reveal(location.hash);
    syncButton();
    sync();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      controller.abort();
      buttonObserver.disconnect();
      resizeObserver?.disconnect();
      cancelAnimationFrame(frame);
      document.documentElement.style.setProperty('--cx-chat-clearance', '0px');
    }, {signal});
  };
  document.querySelectorAll('[data-cx-discovery]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cx-discovery]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-learn-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    const init = (hub) => {
      if (hub.dataset.learnReady === 'true') return;
      const controls = hub.querySelector('[data-learn-controls]');
      const form = hub.querySelector('[data-learn-search-form]');
      const query = hub.querySelector('[data-learn-query]');
      const clear = hub.querySelector('[data-learn-clear]');
      const results = hub.querySelector('[data-learn-results]');
      const empty = hub.querySelector('[data-learn-empty]');
      const reset = hub.querySelector('[data-learn-reset]');
      const topics = Array.from(hub.querySelectorAll('[data-learn-topic]'));
      const cards = Array.from(hub.querySelectorAll('[data-learn-card]')).map((element) => ({ element, search: normalise(element.dataset.search), category: element.dataset.category }));
      if (!cards.length) {
        if (controls) controls.hidden = true;
        if (empty) empty.hidden = true;
        hub.dataset.learnReady = 'true';
        return;
      }
      if (!controls || !form || !query || !clear || !results || !empty || !reset) return;
      let category = 'all';
      const update = () => {
        const terms = normalise(query.value).split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach((card) => {
          const matches = (category === 'all' || category === card.category) && terms.every((term) => card.search.includes(term));
          card.element.hidden = !matches;
          if (matches) count += 1;
        });
        topics.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.learnTopic === category)));
        clear.hidden = query.value.length === 0;
        empty.hidden = count !== 0;
        results.textContent = results.dataset.label.replace('__COUNT__', String(count)).replace('__TOTAL__', String(cards.length));
      };
      form.addEventListener('submit', (event) => { event.preventDefault(); update(); });
      query.addEventListener('input', update);
      clear.addEventListener('click', () => { query.value = ''; update(); query.focus(); });
      topics.forEach((button) => button.addEventListener('click', () => { category = button.dataset.learnTopic; update(); }));
      reset.addEventListener('click', () => { category = 'all'; query.value = ''; update(); query.focus(); });
      hub.dataset.learnReady = 'true';
      update();
      controls.hidden = false;
    };
    document.querySelectorAll('[data-learn-hub]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-learn-hub]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.cxReady) return;
    root.dataset.cxReady = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    const mobileQuery = window.matchMedia('(max-width: 760px)');
    const slides = Array.from(root.querySelectorAll('[data-cx-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-cx-thumb]'));
    const track = root.querySelector('[data-cx-media-track]');
    const mediaCurrent = root.querySelector('[data-cx-media-current]');
    const gallery = root.querySelector('[data-cx-gallery]');
    let current = 0;
    let galleryFrame = 0;
    const setMedia = index => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.hidden = !mobileQuery.matches && !active;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
        if (!active) slide.querySelectorAll('iframe').forEach(frame => {
          if (frame.src.includes('youtube')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), 'https://www.youtube.com');
          if (frame.src.includes('vimeo')) frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), 'https://player.vimeo.com');
        });
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
      if (mediaCurrent) mediaCurrent.textContent = String(current + 1);
      const strip = thumbs[current]?.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        const thumbBox = thumbs[current].getBoundingClientRect();
        const stripBox = strip.getBoundingClientRect();
        strip.scrollTo({left: strip.scrollLeft + thumbBox.left - stripBox.left - (stripBox.width - thumbBox.width) / 2, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    };
    const scrollMedia = smooth => {
      if (!track || !mobileQuery.matches || !slides[current]) return;
      track.scrollTo({left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
    };
    const showMedia = index => {
      setMedia(index);
      scrollMedia(true);
    };
    const syncGalleryMode = () => {
      root.dataset.cxGallerySwipe = String(mobileQuery.matches && slides.length > 1);
      setMedia(current);
      if (track) {
        if (mobileQuery.matches) requestAnimationFrame(() => scrollMedia(false));
        else track.scrollTo({left:0,behavior:'instant'});
      }
    };
    const readGalleryPosition = () => {
      galleryFrame = 0;
      if (!track || !mobileQuery.matches || !slides.length) return;
      const bounds = track.getBoundingClientRect();
      const center = bounds.left + bounds.width / 2;
      const nearest = slides.reduce((best, slide, index) => {
        const rect = slide.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        return distance < best.distance ? { index, distance } : best;
      }, { index: current, distance: Infinity });
      if (nearest.index !== current) setMedia(nearest.index);
    };
    track?.addEventListener('scroll', () => {
      if (!galleryFrame) galleryFrame = requestAnimationFrame(readGalleryPosition);
    }, {passive:true,signal});
    track?.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      showMedia(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal});
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showMedia(index), {signal});
      thumb.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
        showMedia(next);
        thumbs[next].focus();
      }, {signal});
    });
    root.querySelector('[data-cx-media-prev]')?.addEventListener('click', () => showMedia(current - 1), {signal});
    root.querySelector('[data-cx-media-next]')?.addEventListener('click', () => showMedia(current + 1), {signal});
    mobileQuery.addEventListener('change', syncGalleryMode, {signal});
    syncGalleryMode();
    // The gallery stays in view beside a taller purchase panel; its height lets CSS keep the whole gallery on screen.
    const galleryObserver = gallery && typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
      const value = `${Math.ceil(gallery.getBoundingClientRect().height)}px`;
      if (root.style.getPropertyValue('--cx-gallery-height') !== value) root.style.setProperty('--cx-gallery-height', value);
    }) : null;
    galleryObserver?.observe(gallery);
    const form = root.querySelector('.cx-product-form');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const stickyAdd = root.querySelector('[data-cx-sticky-add]');
    const mainAdd = form?.querySelector('[data-cx-add]');
    const moneyFormatter = new Intl.NumberFormat(root.dataset.cxLocale || 'en', {style:'currency', currency:root.dataset.cxCurrency});
    const priceScale = 10 ** Math.max(2, moneyFormatter.resolvedOptions().maximumFractionDigits);
    // Subscribe & save is preselected on every load (Alex, 2 Oct 2026): an earlier choice is not restored.
    const updatePlan = () => {
      const selected = form?.querySelector('input[name="selling_plan"]:checked') || form?.querySelector('[data-cx-one-time-price]');
      if (!selected) {
        if (mainAdd) mainAdd.disabled = true;
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      const quantity = quantityInput ? Number(quantityInput.value) : 1;
      form?.querySelectorAll('[data-cx-quantity-step]').forEach(button => {
        const step = Number(button.dataset.cxQuantityStep);
        button.disabled = step < 0 && (!Number.isSafeInteger(quantity) || quantity <= 1);
      });
      const unitPrice = Number(selected.dataset.cxPlanCents);
      const total = unitPrice * quantity;
      const valid = Number.isSafeInteger(quantity) && quantity >= 1 && (!quantityInput || quantityInput.validity.valid) && Number.isSafeInteger(unitPrice) && unitPrice >= 0 && Number.isSafeInteger(total);
      if (mainAdd) mainAdd.disabled = !valid || mainAdd.dataset.cxCanPurchase === 'false' || !!form?.dataset.busy;
      const formatted = valid ? (quantity === 1 ? selected.dataset.cxPlanPrice : moneyFormatter.format(total / priceScale)) : '';
      root.querySelectorAll('[data-cx-selected-price]').forEach((price) => { price.textContent = formatted; price.hidden = !valid; });
      root.querySelectorAll('[data-cx-price-divider]').forEach((divider) => { divider.hidden = !valid; });
      root.querySelectorAll('[data-cx-sticky-quantity]').forEach((count) => {
        count.textContent = valid ? count.dataset.cxQuantityTemplate.replace('__count__', String(quantity)) : '';
        count.hidden = !valid;
      });
      const purchaseSummary = root.querySelector('[data-cx-purchase-summary]');
      if (purchaseSummary) purchaseSummary.hidden = !valid;
      const purchaseQuantity = root.querySelector('[data-cx-purchase-quantity]');
      if (purchaseQuantity) purchaseQuantity.textContent = valid ? purchaseQuantity.dataset.cxQuantityTemplate.replace('__count__', String(quantity)) : '';
      const afterPrice = root.querySelector('[data-cx-purchase-after]');
      if (afterPrice) {
        let afterText = afterPrice.dataset.cxOnceLabel;
        if (selected.value !== '') {
          const afterCents = selected.dataset.cxAfterCents;
          const afterUnitPrice = afterCents == null || afterCents.trim() === '' ? null : Number(afterCents);
          const afterTotal = afterUnitPrice === null ? null : afterUnitPrice * quantity;
          const hasFixedRenewal = valid && Number.isSafeInteger(afterUnitPrice) && afterUnitPrice >= 0 && Number.isSafeInteger(afterTotal);
          const afterFormatted = hasFixedRenewal ? (quantity === 1 && selected.dataset.cxAfterPrice ? selected.dataset.cxAfterPrice : moneyFormatter.format(afterTotal / priceScale)) : '';
          afterText = hasFixedRenewal ? afterPrice.dataset.cxMonthlyTemplate.replace('__price__', afterFormatted) : (selected.dataset.cxPlanName || selected.dataset.cxPlanSummary);
        }
        afterPrice.textContent = valid ? afterText : '';
      }
      root.querySelectorAll('[data-cx-sticky-summary]').forEach((summary) => { summary.textContent = selected.dataset.cxPlanSummary; });
      const billing = root.querySelector('[data-cx-billing]');
      if (billing) billing.hidden = selected.value === '';
      if (stickyAdd) {
        stickyAdd.disabled = !valid || !!form?.dataset.busy || !!form?.querySelector('[data-cx-add]')?.disabled;
      }
    };
    form?.querySelectorAll('input[name="selling_plan"]').forEach((radio) => {
      radio.addEventListener('change', updatePlan, {signal});
    });
    form?.querySelectorAll('[data-cx-quantity-step]').forEach(button => {
      button.addEventListener('click', () => {
        if (!quantityInput) return;
        const current = Number(quantityInput.value);
        const step = Number(button.dataset.cxQuantityStep);
        const next = Math.max(1, (Number.isSafeInteger(current) ? current : 1) + step);
        if (!Number.isSafeInteger(next)) return;
        quantityInput.value = String(next);
        quantityInput.dispatchEvent(new Event('input', {bubbles:true}));
      }, {signal});
    });
    form?.addEventListener('submit', event => {
      updatePlan();
      if (mainAdd?.disabled) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      queueMicrotask(updatePlan);
    }, {signal});
    quantityInput?.addEventListener('input', updatePlan);
    quantityInput?.addEventListener('change', updatePlan);
    form?.addEventListener('cx:purchase-updated', updatePlan);
    window.addEventListener('pageshow', updatePlan);
    updatePlan();
    root.querySelectorAll('a[href^="#CxSubscription-"]').forEach((link) => link.addEventListener('click', () => {
      const details = document.getElementById(link.getAttribute('href').slice(1));
      if (details) details.open = true;
    }));
    const buy = root.querySelector('.cx-pdp__purchase');
    const buyingControls = root.querySelector('.cx-pdp__buy-row');
    const plans = root.querySelector('.cx-pdp__plans');
    const sticky = root.querySelector('[data-cx-sticky]');
    let stickyFrame = 0;
    const measureChatClearance = excludeOwn => {
      let ownHeight = 0;
      const clearance = Array.from(document.querySelectorAll('[data-cx-sticky]:not([hidden])')).reduce((height, bar) => {
        if (bar === sticky && excludeOwn) return height;
        const barHeight = Math.ceil(bar.getBoundingClientRect().height);
        if (bar === sticky) ownHeight = barHeight;
        return Math.max(height, barHeight);
      }, 0);
      return {clearance,ownHeight};
    };
    const syncChatClearance = ({clearance,ownHeight}) => {
      const chatValue = `${clearance}px`;
      const productValue = `${ownHeight}px`;
      if (document.documentElement.style.getPropertyValue('--cx-chat-clearance') !== chatValue) document.documentElement.style.setProperty('--cx-chat-clearance', chatValue);
      if (root.style.getPropertyValue('--cx-product-sticky-height') !== productValue) root.style.setProperty('--cx-product-sticky-height', productValue);
    };
    const syncSticky = () => {
      stickyFrame = 0;
      if (!buy || !sticky) return;
      const purchaseRect = buy.getBoundingClientRect();
      const purchaseInView = mobileQuery.matches && purchaseRect.top < window.innerHeight && purchaseRect.bottom > 0;
      let hidden;
      if (mobileQuery.matches && buyingControls) {
        const rect = buyingControls.getBoundingClientRect();
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cx-header-height')) || 0;
        const navHeight = root.querySelector('[data-cx-guided-product-nav]')?.getBoundingClientRect().height || 0;
        hidden = rect.top >= headerHeight + navHeight + 12 && rect.bottom <= window.innerHeight - 12;
      } else {
        hidden = purchaseRect.bottom > 110;
      }
      const purchaseChanged = root.hasAttribute('data-cx-purchase-in-view') !== purchaseInView;
      const visibilityChanged = sticky.hidden !== hidden;
      const measureAfterStateChange = !hidden && (purchaseChanged || visibilityChanged);
      const measurements = measureChatClearance(hidden || measureAfterStateChange);
      if (purchaseChanged) root.toggleAttribute('data-cx-purchase-in-view', purchaseInView);
      if (visibilityChanged) sticky.hidden = hidden;
      // A newly visible or restyled bar needs its current height immediately.
      // Otherwise all geometry is read before any attribute or style writes.
      if (measureAfterStateChange) {
        measurements.ownHeight = Math.ceil(sticky.getBoundingClientRect().height);
        measurements.clearance = Math.max(measurements.clearance, measurements.ownHeight);
      }
      syncChatClearance(measurements);
    };
    const scheduleSticky = () => {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky);
    };
    const stickyObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleSticky) : null;
    if (stickyObserver) {
      if (sticky) stickyObserver.observe(sticky);
      if (buy) stickyObserver.observe(buy);
    }
    window.addEventListener('scroll', scheduleSticky, {passive:true,signal});
    window.addEventListener('resize', scheduleSticky, {passive:true,signal});
    mobileQuery.addEventListener('change', scheduleSticky, {signal});
    syncSticky();
    // Handle every purchase anchor before the detail navigation can handle it.
    root.addEventListener('click', event => {
      const link = event.target.closest?.('a');
      if (!plans?.id || !link || !root.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.hash !== '#' + plans.id || link.origin !== window.location.origin || link.pathname !== window.location.pathname || link.search !== window.location.search || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
      event.preventDefault();
      if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
      const nav = root.querySelector('[data-cx-guided-product-nav]');
      const headerHeight = nav ? parseFloat(getComputedStyle(nav).top) || 0 : parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cx-header-height')) || 0;
      const clearance = headerHeight + (nav?.getBoundingClientRect().height || 0) + 20;
      window.scrollTo({top:Math.max(0,window.scrollY + plans.getBoundingClientRect().top - clearance),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      const selected = form?.querySelector('input[name="selling_plan"]:checked') || form?.querySelector('input[name="selling_plan"]');
      selected?.focus({preventScroll:true});
    }, {capture:true,signal});
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      controller.abort();
      stickyObserver?.disconnect();
      galleryObserver?.disconnect();
      cancelAnimationFrame(galleryFrame);
      cancelAnimationFrame(stickyFrame);
      const measurements = measureChatClearance(true);
      if (sticky && !sticky.hidden) sticky.hidden = true;
      if (root.hasAttribute('data-cx-purchase-in-view')) root.removeAttribute('data-cx-purchase-in-view');
      syncChatClearance(measurements);
    }, {signal});
  };
  const revealBackground = hash => {
    if (!hash || hash.length < 2) return;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
    const target = document.getElementById(id);
    if (!target?.closest('.cx-pdp')) return;
    let disclosure = target.closest('details');
    let opened = false;
    while (disclosure) {
      if (!disclosure.open) { disclosure.open = true; opened = true; }
      disclosure = disclosure.parentElement?.closest('details');
    }
    if (opened) requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
  };
  window.addEventListener('hashchange', () => revealBackground(window.location.hash));
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a');
    if (link?.hash && link.origin === window.location.origin && link.pathname === window.location.pathname) revealBackground(link.hash);
  });
  revealBackground(window.location.hash);
  document.querySelectorAll('[data-cx-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-cx-pdp]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-selector"] && !Shopify.designMode) return;
  try {
    
  function initializeCxSelector(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const controls = root.querySelector('[data-guide-controls]');
    const buttons = Array.from(root.querySelectorAll('[data-guide-filter]'));
    const results = root.querySelector('[data-guide-results]');
    const products = Array.from(root.querySelectorAll('[data-guide-product]'));
    const status = root.querySelector('[data-guide-status]');
    controls.hidden = false;
    function select(handle) {
      const selectedProduct = products.find((item) => item.dataset.guideProduct === handle);
      const selectedFilter = selectedProduct ? handle : 'all';
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.guideFilter === selectedFilter)));
      results.classList.toggle('is-single', Boolean(selectedProduct));
      products.forEach((item) => { item.hidden = Boolean(selectedProduct) && item !== selectedProduct; });
      status.textContent = status.dataset.countLabel.replace('__count__', String(products.filter((item) => !item.hidden).length));
    }
    buttons.forEach((button) => button.addEventListener('click', () => select(button.dataset.guideFilter)));
    select('all');
  }
  document.querySelectorAll('[data-cx-selector]').forEach(initializeCxSelector);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-cx-selector]').forEach(initializeCxSelector));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sync-system"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    const track = root.querySelector('[data-cx-bestsellers]');
    const controls = root.querySelector('[data-cx-bestseller-controls]');
    if (!track || !controls || track.dataset.ready) return;
    track.dataset.ready = 'true';
    const previous = controls.querySelector('[data-cx-bestseller-previous]');
    const next = controls.querySelector('[data-cx-bestseller-next]');
    const count = controls.querySelector('[data-cx-bestseller-count]');
    const cards = Array.from(track.children).filter(card => card.matches('.merge-home-tile'));
    const positions = () => {
      const limit = Math.max(0, track.scrollWidth - track.clientWidth);
      const origin = track.getBoundingClientRect().left;
      const padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      return cards.map(card => Math.max(0, Math.min(limit, card.getBoundingClientRect().left - origin + track.scrollLeft - padding)));
    };
    const current = targets => targets.reduce((best, target, index) => Math.abs(target - track.scrollLeft) < Math.abs(targets[best] - track.scrollLeft) ? index : best, 0);
    const update = () => {
      const overflow = cards.length > 1 && track.scrollWidth > track.clientWidth + 3;
      controls.hidden = !overflow;
      if (!overflow) { track.removeAttribute('tabindex'); return; }
      track.tabIndex = 0;
      const index = current(positions());
      const label = `${index + 1} / ${cards.length}`;
      if (count.textContent !== label) count.textContent = label;
      previous.disabled = index === 0;
      next.disabled = index === cards.length - 1;
    };
    const move = direction => {
      const targets = positions();
      if (!targets.length) return;
      const destination = Math.max(0, Math.min(targets.length - 1, current(targets) + direction));
      track.scrollTo({left: targets[destination], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    requestAnimationFrame(update);
  };
  document.querySelectorAll('.cx-guided-products').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cx-guided-products').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sync-wholesale"]) return;
  try {
    
  (() => {
    const pendingKey = 'sync-b2b-order-pending';
    const initialize = (scope) => scope.querySelectorAll('[data-sync-b2b-order]').forEach((section) => {
      const configElement = section.querySelector('[data-order-config]');
      if (!configElement || section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const config = JSON.parse(configElement.textContent);
      const form = section.querySelector('[data-order-form]');
      const button = section.querySelector('[data-order-review]');
      const status = section.querySelector('[data-order-status]');
      const subtotal = section.querySelector('[data-order-subtotal]');
      const otherItems = section.querySelector('[data-order-other]');
      const formatter = new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency });
      const scale = 10 ** Math.max(2, formatter.resolvedOptions().maximumFractionDigits);
      const money = (value) => formatter.format(value / scale);
      const rows = Array.from(section.querySelectorAll('[data-order-row]'), (element) => ({
        element,
        id: element.dataset.variant,
        price: Number(element.dataset.price),
        min: Number(element.dataset.min),
        increment: Number(element.dataset.increment),
        max: element.dataset.max === '' ? Number.MAX_SAFE_INTEGER : Number(element.dataset.max),
        available: element.dataset.available === 'true',
        input: element.querySelector('[data-order-quantity]'),
        error: element.querySelector('[data-order-error]'),
        unit: element.querySelector('[data-order-unit]'),
        line: element.querySelector('[data-order-line]'),
        tiers: Array.from(element.querySelectorAll('[data-order-tier]'), (tier) => ({ minimum: Number(tier.dataset.quantity), price: Number(tier.dataset.price) })).sort((a, b) => a.minimum - b.minimum),
        blocked: false
      }));
      let cart;
      let busy = true;
      let locked = false;
      const tell = (key, error = false) => { status.textContent = config.text[key]; status.dataset.error = String(error); };
      const itemsFor = (snapshot, row) => snapshot.items.filter((item) => String(item.variant_id) === row.id);
      const complex = (items) => items.length > 1 || items.some((item) => item.selling_plan_allocation || item.parent_relationship || (item.item_components && item.item_components.length) || Object.keys(item.properties || {}).length > 0);
      const count = (items) => items.reduce((total, item) => total + item.quantity, 0);
      const quantity = (row) => {
        const raw = row.input.value;
        if (!/^\d+$/.test(raw)) return null;
        const value = Number(raw);
        if (!Number.isSafeInteger(value) || value < 0 || value > row.max) return null;
        if (value !== 0 && (value < row.min || value % row.increment !== 0)) return null;
        return value;
      };
      const unitPrice = (row, amount) => row.tiers.reduce((price, tier) => amount >= tier.minimum ? tier.price : price, row.price);
      const recalculate = () => {
        let total = 0;
        let valid = true;
        rows.forEach((row) => {
          if (row.blocked) { row.line.textContent = money(0); return; }
          const amount = quantity(row);
          const unit = unitPrice(row, amount || 0);
          const line = amount === null ? null : amount * unit;
          const validRow = line !== null && Number.isSafeInteger(line) && line >= 0 && Number.isSafeInteger(total + line);
          row.input.setAttribute('aria-invalid', String(!validRow));
          row.error.hidden = validRow;
          row.error.textContent = validRow ? '' : config.text.invalid;
          row.unit.textContent = money(unit);
          row.line.textContent = validRow ? money(line) : '—';
          if (validRow) total += line; else valid = false;
        });
        subtotal.textContent = valid ? money(total) : '—';
        button.disabled = busy || locked || !valid || rows.length === 0;
        return valid;
      };
      const sync = (snapshot) => {
        cart = snapshot;
        let outside = false;
        rows.forEach((row) => {
          const items = itemsFor(snapshot, row);
          row.blocked = complex(items) || !row.available;
          row.input.value = String(count(items));
          row.input.disabled = busy || locked || row.blocked;
          row.error.hidden = !row.blocked || items.length === 0;
          row.error.textContent = complex(items) ? config.text.complex : config.text.unavailable;
          if (row.blocked && items.length) outside = true;
        });
        otherItems.hidden = !outside && snapshot.items.every((item) => rows.some((row) => row.id === String(item.variant_id)));
        recalculate();
      };
      const setBusy = (value) => {
        busy = value;
        form.setAttribute('aria-busy', String(value));
        button.textContent = config.text[value ? 'saving' : 'review'];
        rows.forEach((row) => { row.input.disabled = value || locked || row.blocked; });
        recalculate();
      };
      const readCart = async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(config.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('error');
          const snapshot = await response.json();
          if (!Array.isArray(snapshot.items) || snapshot.items.some((item) => !Number.isSafeInteger(item.quantity) || item.quantity < 0)) throw new Error('error');
          if (snapshot.currency !== config.currency) throw new Error('currency');
          return snapshot;
        } finally { clearTimeout(timeout); }
      };
      const matches = (left, right) => rows.every((row) => {
        const before = itemsFor(left, row);
        const after = itemsFor(right, row);
        return JSON.stringify(before.map((item) => [item.key, item.quantity])) === JSON.stringify(after.map((item) => [item.key, item.quantity]));
      });
      const readPending = () => {
        try { return JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); }
        catch { throw new Error('storage'); }
      };
      const clearPending = () => { try { sessionStorage.removeItem(pendingKey); } catch { throw new Error('storage'); } };
      const writePending = (row, amount) => {
        try { sessionStorage.setItem(pendingKey, JSON.stringify({ variantId: row.id, quantity: amount, location: config.location, currency: config.currency })); }
        catch { throw new Error('storage'); }
      };
      form.addEventListener('input', (event) => { if (event.target.matches('[data-order-quantity]')) recalculate(); });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || locked || !recalculate()) return;
        const desired = rows.filter((row) => !row.blocked).map((row) => ({ row, amount: quantity(row) }));
        setBusy(true);
        tell('saving');
        try {
          const latest = await readCart();
          if (!matches(cart, latest)) { sync(latest); throw new Error('changed'); }
          cart = latest;
          for (const { row, amount } of desired) {
            const fresh = await readCart();
            if (!matches(cart, fresh)) { sync(fresh); throw new Error('changed'); }
            cart = fresh;
            const items = itemsFor(cart, row);
            if (complex(items)) throw new Error('changed');
            if (count(items) === amount) continue;
            writePending(row, amount);
            let response;
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 20000);
            try {
              response = await fetch(items.length ? config.changeUrl : config.addUrl, {
                method: 'POST', credentials: 'same-origin', signal: controller.signal,
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(items.length ? { id: items[0].key, quantity: amount } : { items: [{ id: row.id, quantity: amount }] })
              });
            } catch { locked = true; throw new Error('uncertain'); }
            finally { clearTimeout(timeout); }
            const confirmed = await readCart();
            clearPending();
            cart = confirmed;
            if (!response.ok || complex(itemsFor(confirmed, row)) || count(itemsFor(confirmed, row)) !== amount) { sync(confirmed); throw new Error('rejected'); }
          }
          const confirmed = await readCart();
          if (!matches(cart, confirmed)) { sync(confirmed); throw new Error('changed'); }
          if (!confirmed.items.length) { sync(confirmed); throw new Error('empty'); }
          window.location.assign(config.cartUrl);
        } catch (error) {
          try { if (readPending()) locked = true; }
          catch { locked = true; tell('storage', true); setBusy(false); return; }
          tell(locked ? 'uncertain' : (config.text[error.message] ? error.message : 'error'), true);
          setBusy(false);
        }
      });
      (async () => {
        try {
          const snapshot = await readCart();
          const pending = readPending();
          if (pending) {
            const items = snapshot.items.filter((item) => String(item.variant_id) === String(pending.variantId));
            if (pending.location === config.location && pending.currency === config.currency && !complex(items) && count(items) === pending.quantity) clearPending();
            else locked = true;
          }
          sync(snapshot);
          tell(locked ? 'uncertain' : 'ready', locked);
        } catch (error) { locked = true; tell(config.text[error.message] ? error.message : 'error', true); }
        setBusy(false);
      })();
    });
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
